const config = {
  rootUrl:'http://ginop522.vallalkozzitthon.hu/',
  db: {
    host: 'localhost',
    port: '28015',
    db: 'vi_del_dunantul'
  },
  mailchimp: {
    api_key: 'ed191cb4ecbdaadfd3d9236c5ebdb042-us12'
  },
  smtp: {
    host: 'localhost',
    port: 25, //465,
    //secure: true, // use SSL
    //auth: {
    //  user: 'user@gmail.com',
    //  pass: 'pass'
    //}
  },
  token_secret: '3213213mASASdds32423llo2'
};


export default config;



/** WEBPACK FOOTER **
 ** ./server/config.js
 **/